/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Grid, Tooltip, Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Box from '@mui/material/Box';
import { AlertDialog } from './../../Common/AlertDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import SearchNotFound from '../../../SearchNotFound';
import Chip from '@material-ui/core/Chip';
import _ from 'lodash';
import { LoadingComponent } from 'src/pages/pageLoader';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { Autocomplete } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
var screenCode = 'PRICEUPDATE';

export default function PriceUpdate() {
  const classes = useStyles();
  const componentRef = useRef();
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [PriceData, setPriceData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [MarketData, setMarketData] = useState([]);
  const [columData, setColumData] = useState([]);
  const [columDataOne, setColumDataOne] = useState([]);
  const [ApprovedPopUp, setApprovedPopUp] = useState();
  const [message, setMessage] = useState('Approved Price Add Confirmation');
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [RealizeApprovePopUp, setRealizeApprovePopUp] = useState();
  const [messageRealizedApprove, setMessageRealizedApprove] = useState('Approve Realized Price Confirmation');
  const [EnableRealizeApproveConfirmMessage, setEnableRealizeApproveConfirmMessage] = useState(false);
  const [EnableSndPPApproveConfirmMessage, setEnableSndPPApproveConfirmMessage] = useState(false);
  const [EnableSndPPRejectConfirmMessage, setEnableSndPPRejectConfirmMessage] = useState(false);
  const [RealizeRejectPopUp, setRealizeRejectPopUp] = useState();
  const [SndPPRejectPopUp, setSndPPRejectPopUp] = useState();
  const [SndPPApprovePopUp, setSndPPApprovePopUp] = useState();
  const [messageRealizedReject, setMessageRealizedReject] = useState('Reject Realized Price Confirmation');
  const [messageSndPPReject, setMessageSndPPReject] = useState('Reject 2nd Proposed Price Confirmation');
  const [messageSndPPApprove, setMessageSndPPApprove] = useState('Approve 2nd Proposed Price Confirmation');
  const [EnableRealizeRejectConfirmMessage, setEnableRealizeRejectConfirmMessage] = useState(false);
  const [updateRealized, setUpdateRealized] = useState(false);
  const [isFarmerClear, setIsFarmerClear] = useState(false);
  const [Datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));
  const [isUpdate, setIsUpdate] = useState(false);
  const [open, setOpen] = useState(false);
  const [MarketCount, setMarketCount] = useState(0);
  const [MarketHeader, setMarketHeader] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [isTable, setIsTable] = useState(true);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0,
    productCategoryID: 0,
    cropID: 0,
    date: new Date().toISOString().split('T', 1)
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: '',
    operationEntityID: '',
    productCategoryID: '',
    cropID: '',
    date: ''
  });

  const priceUpdateSearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntityID: Yup.number().notRequired(),
    date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required'),
    productCategoryID: Yup.number().notRequired(),
    cropID: Yup.number().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      date: formData.date,
      productCategoryID: formData.productCategoryID,
      cropID: formData.cropID
    },
    validationSchema: priceUpdateSearchSchema,
  });

  const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    trackPromise(GetProductDetails());
    clearFields();
    setPriceData([]);
    setIsFarmerClear(!isFarmerClear);
  }, [formik.values.productCategoryID]);

  useEffect(() => {
    setPriceData([]);
    setIsFarmerClear(!isFarmerClear);
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setPriceData([]);
  }, [formik.values.cropID]);

  useEffect(() => {
    setPriceData([]);
    setIsFarmerClear(!isFarmerClear);
  }, [Datevalue]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWPRICEUPDT');
  
    if (isAuthorized === undefined) {
      navigate('/404');
    }
  
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');
  
    const isGroupPermitted = isGroupFilterEnabled !== undefined;
    const isFactoryPermitted = isFactoryFilterEnabled !== undefined;
  
    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupPermitted,
      isFactoryFilterEnabled: isFactoryPermitted
    });
  
    const userGroup = parseInt(TokenDecoder.getGroupFactoryToken().group);
    const userFactory = parseInt(TokenDecoder.getGroupFactoryToken().factory);
  
    //const initialGroupID = isGroupPermitted ? 0 : userGroup;
    const initialOperationEntityID = isFactoryPermitted ? 0 : userFactory;
  
    setValues({
      groupID: userGroup,
      operationEntityID: initialOperationEntityID,
      date: new Date().toISOString().split('T', 1)[0],
      productCategoryID: 0,
      cropID: 0
    });
  
    trackPromise(GetAllGroups());
    trackPromise(GetProductCategoties());
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  function generateGroupForDropDownMenu(data) {
    let items = [];
    if (data != null) {
      data.forEach((x) => {
        items.push(
          <MenuItem key={x.groupID} value={x.groupID}>
            {x.groupName}
          </MenuItem>
        );
      });
    }
    return items;
  }

  function generateOperationEntityForDropDownMenu(data) {
    let items = [];
    if (data != null) {
      data.forEach((x) => {
        x.factoryType == 2 ?
          items.push(
            <MenuItem key={x.factoryID} value={x.factoryID}>
              {x.factoryName}
            </MenuItem>
          ) : null
      });
    }
    return items;
  }

  async function GetProductCategoties() {
    var res = await services.GetProductCategoties();
    if (res != null) {
      setProductcatogery(res);
    }
  }

  async function GetProductDetails() {
    var res = await services.GetProductsByFactoryIDProductcatogeryID(
      formik.values.operationEntityID,
      formik.values.productCategoryID
    );
    if (res != null) {
      setProductList(res);
    }
  }

  async function SearchData() {
    let model = {
      operationEntityID: formik.values.operationEntityID,
      date: new Date(Datevalue).toISOString(),
      productCategoryID: formik.values.productCategoryID,
      cropID: formik.values.cropID != 0 ? formik.values.cropID : 0
    };
    const result = await services.GetPriceUpdateDetails(model);
    const found = result;
    var response = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    let usersArray = [];
    for (let item of Object.entries(response)) {
      usersArray[item[1]['factoryID']] = item[1]['factoryName'];
    }
    found.forEach((x) => {
      x.operationEntity = usersArray[x.operationEntityID];
    });
    let newRes = _.cloneDeep(found);
    const groupedData = _.groupBy(newRes, 'cropID');
    const results = _.map(groupedData, (dataList, cropID) => ({ cropID, dataList }));

    results.forEach((x) => {
      x.productName = x.dataList[0].productName
    });
    results.sort((a, b) => a.productName.toLowerCase() > b.productName.toLowerCase() ? 1 : -1);
    setInitialData(found)
    setPriceData(results)
    createVccList(newRes)
    getSelectedDropdownValuesForReport();
  }


  function createVccList(data) {
    let columns = [];
    let columnsOne = [];
    const vccUniqueData = [...new Set(data.map(item => item.operationEntityID))].map(name => {
      return data.find(item => item.operationEntityID === name);
    });
    vccUniqueData.forEach(x => {
      columns.push({ title: x.operationEntity, key: x.operationEntityID });
    });
    vccUniqueData.forEach(x => {
      columnsOne.push({ title: 'Qty(KG)', key: 'quantity' });
      columnsOne.push({ title: 'Status', key: 'status' });
      columnsOne.push({ title: 'PP(LKR)', key: 'proposedPrice' });
      columnsOne.push({ title: 'AP(LKR)', key: 'approvedPrice' });
      columnsOne.push({ title: 'Reorder Price Status', key: 'secondProposedPriceStatus' });
      columnsOne.push({ title: 'Reorder Price(LKR)', key: 'secondProposedPrice' });
      columnsOne.push({ title: 'RP(LKR)', key: 'realizedPrice' });
      columnsOne.push({ title: 'Realized Price Status', key: 'realizedPriceStatus' });
    });
    setColumData(columns)
    setColumDataOne(columnsOne)
  }

  function changeText(e, index, cropID, vcc) {
    setIsUpdate(true)
    const target = e.target;
    const value = target.value;
    const newArr = [...PriceData];
    const valueTwo = value == "" ? null : parseFloat(value)

    newArr.forEach(x => {
      if (x.cropID == cropID) {
        x.dataList.forEach(y => {
          if (y.operationEntityID == vcc) {
            y.approvedPrice = parseFloat(valueTwo)
          }
        })
      }
    })
    setPriceData(newArr);
  }

  async function UpdateDailyPriceUpdateDetails() {
    let newRes = _.cloneDeep(PriceData);
    let newinitialData = _.cloneDeep(initialData);
    const newResult = createUpdateList(newRes, newinitialData)
    let newArray = newResult.filter((y) => {
      return newinitialData.some((x) => x.approvedPrice !== y.approvedPrice);
    });
    const found = newArray.filter((x) => x.proposedPrice > 0 && x.status != 3);
    found.forEach((x) => {
      x.operationEntityID = parseInt(formik.values.operationEntityID);
      x.modifiedBy = parseInt(TokenDecoder.getUserIDFromToken());
    });
    var res = await services.UpdateDailyPriceUpdateDetails(found);
    if (res.statusCode === 'Success') {
      toast.success('Approved Price Updated Succesfully');
      setIsUpdate(false)
      trackPromise(SearchData(formik.values));
    } else {
      toast.error('Error occured in Approved Price Update');
    }
  }

  function createUpdateList(newRes, oldRes) {
    let newArray = [];
    newRes.forEach(x => {
      x.dataList.forEach(y => {
        newArray.push(y)
      })
    })
    const changedObjects = newArray.filter(newObj => {
      const matchingOldObj = oldRes.find(oldObj => oldObj.approvedPrice === newObj.approvedPrice);
      return !_.isEqual(newObj, matchingOldObj);
    });
    return changedObjects
  }

  async function handleHartiPriceView() {
    let model = {
      cropID: parseInt(0),
      date: new Date(Datevalue).toISOString()
    };
    var res = await services.GetAllMarketPriceDetails(model);
    let newinitialData = _.cloneDeep(PriceData);
    let newArray = [];
    newinitialData.forEach(x => {
      const matchingOldObj = res.find(oldObj => oldObj.productID === parseInt(x.cropID));
      if (matchingOldObj) {
        newArray.push(matchingOldObj)
      }
    })
    var lengths = newArray.map(function (edge) {
      return edge.priceModel.length;
    });
    var maxLength = Math.max(...lengths);
    let header = [];
    for (let index = 0; index < maxLength; index++) {
      header.push({ title: 'market', key: 'Market' });
      header.push({ title: 'min', key: 'Min' });
      header.push({ title: 'max', key: 'Max' });
    }
    if (newArray != null) {
      setMarketHeader(header)
      setMarketCount(maxLength)
      setMarketData(newArray);
      setOpen(true)
    }
  }

  async function handleRealizePriceApprove(value) {
    let model = {
      productPriceID: parseInt(value.productPriceID),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
      isRealizedEdited: false,
      operationEntity: value.operationEntity,
      productName: value.productName,
      realizedPriceStatus: parseInt(3)
    }
    var res = await services.RealizedPriceApproveDetails(model);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
      setIsUpdate(false);
      setUpdateRealized(false);
      setEnableRealizeApproveConfirmMessage(false)
    } else {
      toast.error(res.message);
    }
  }

  async function handleRealizePriceReject(value) {
    let model = {
      productPriceID: parseInt(value.productPriceID),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
      isRealizedEdited: false,
      previousRealizedPrice: parseFloat(value.previousRealizedPrice),
      operationEntityName: value.operationEntity,
      productName: value.productName,
      realizedPriceStatus: parseInt(4)
    }
    var res = await services.RealizedPriceRejectDetails(model);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
      setIsUpdate(false);
      setUpdateRealized(false);
    } else {
      toast.error(res.message);
    }
  }

  async function handleSndPPReject(value) {
    let model = {
      productPriceID: parseInt(value.productPriceID),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
      operationEntity: value.operationEntity,
      productName: value.productName
    }
    var res = await services.SndPPRejectDetails(model);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
      setIsUpdate(false);
    } else {
      toast.error(res.message);
    }
  }

  async function handleSndPPApprove(value) {
    let model = {
      productPriceID: parseInt(value.productPriceID),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
      operationEntity: value.operationEntity,
      productName: value.productName
    }
    var res = await services.SndPPApproveDetails(model);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
      setIsUpdate(false);
    } else {
      toast.error(res.message);
    }
  }

  async function createFile() {
    var file = await createDataForExcel(PriceData);
    var settings = {
      sheetName: 'Approved Price',
      fileName: 'Product Approved Prices - ' + selectedSearchValues.date,
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'Product Approve Price',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        x.dataList.map(data => {
          var vr = {
            'Crop Name': x.productName,
            'Fresh Collection Center': data.operationEntity,
            'Quantity(KG)': data.quantity.toFixed(2),
            'Status': data.status == 1 ? 'Pending' : data.status == 2 ? 'Pending' : data.status == 3 ? 'Approved' : data.status == 4 ? 'Rejected' : '',
            'PP(LKR)': data.proposedPrice.toFixed(2),
            'AP(LKR)': data.approvedPrice.toFixed(2),
            'Reorder Price(LKR)': data.secondProposedPrice.toFixed(2),
            'RP(LKR)': data.realizedPrice.toFixed(2),
            'Realized Price Status': data.realizedPriceStatus == 0 ? 'Not Set' : data.realizedPriceStatus == 1 ? 'New' : data.realizedPriceStatus == 2 ? 'Pending' : data.realizedPriceStatus == 3 ? 'Approved' : data.realizedPriceStatus == 4 ? 'Rejected' : '',
          };
          res.push(vr);
        });
      });
      res.sort((a, b) => a['Fresh Collection Center'].localeCompare(b['Fresh Collection Center']));
      res.push({});
      res.push({});

      var vr1 = {
        'Crop Name': "Group: " + selectedSearchValues.groupID,
        'Fresh Collection Center': "Fresh Collection Center: " + selectedSearchValues.operationEntityID,
        'Quantity(KG)': "Product Category: " + selectedSearchValues.productCategoryID,
        'Status': "Crop: " + selectedSearchValues.cropID,
        'PP(LKR)': "Date: " + selectedSearchValues.date
      }
      res.push(vr1);
    }
    return res;
  }

  function getSelectedDropdownValuesForReport() {
    let groupData = groupList.find(x => x.groupID == formik.values.groupID);

    let collection =
      formik.values.operationEntityID === 0
        ? ''
        : operationEntityList.find(x => x.factoryID === formik.values.operationEntityID);

    let productCat =
      formik.values.productCategoryID === 0
        ? ''
        : productcatogery.find(x => x.productCategoryID == formik.values.productCategoryID);

    let prod =
      formik.values.cropID === 0 ? '' : productList.find(x => x.productID == formik.values.cropID);

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupID: groupData ? groupData.groupName : '',
      operationEntityID: collection ? collection.factoryName : 'All Fresh Collection Centers',
      productCategoryID: productCat ? productCat.productCategoryName : 'All Product Categories',
      cropID: prod ? prod.productName : 'All Crops',
      date: new Date(Datevalue).toISOString().split('T')[0]
    });
  }

  function confirmData(y) {
    if (y) {
      UpdateDailyPriceUpdateDetails(ApprovedPopUp);
    }
  }
  async function confirmMessage(data) {
    setIsLoading(true);
    setEnableConfirmMessage(true);
    setApprovedPopUp(data);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }

  async function RejectPopUpFunc(data) {
    setEnableRealizeRejectConfirmMessage(true);
    setRealizeRejectPopUp(data)
  }

  async function RejectPopUpFuncSndPP(data) {
    setEnableSndPPRejectConfirmMessage(true);
    setSndPPRejectPopUp(data)
  }

  async function confirmMessageApprove(data) {
    setEnableRealizeApproveConfirmMessage(true);
    setRealizeApprovePopUp(data)
  }

  async function confirmMessageApproveSndPP(data) {
    setEnableSndPPApproveConfirmMessage(true);
    setSndPPApprovePopUp(data)
  }

  function confirmDataRealizedApprove(y) {
    if (y) {
      handleRealizePriceApprove(RealizeApprovePopUp);
    }
  }

  function confirmDataRealizedReject(y) {
    if (y) {
      handleRealizePriceReject(RealizeRejectPopUp);
    }
  }

  function confirmDataSndPPReject(y) {
    if (y) {
      handleSndPPReject(SndPPRejectPopUp);
    }
  }

  function confirmDataSndPPApprove(y) {
    if (y) {
      handleSndPPApprove(SndPPApprovePopUp);
    }
  }

  function handleSearchCrop(data, e) {
    if (data === undefined || data === null) {
      setValues({
        ...values,
        cropID: 0
      });
      return;
    } else {
      var valueV = data["productID"];

      setValues({
        ...values,
        cropID: valueV
      });
    }
  }

  function clearFields() {
    setValues({
      ...values,
      cropID: 0
    });
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <LoadingComponent />
      <Page title="Add Approved Price |  FAPS">
        <Container maxWidth>
          <CommonPageHeader
            path={'/priceU'}
            btname="Add"
            pageName="Add Approved Price"
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Group
                    </MenuItem>
                    {generateGroupForDropDownMenu(groupList)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center "
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      All Fresh Collection Centers
                    </MenuItem>
                    {generateOperationEntityForDropDownMenu(operationEntityList)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    name="productCategoryID"
                    variant="outlined"
                    label="Product Category "
                    value={formik.values.productCategoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('productCategoryID')}
                    error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                    helperText={touched.productCategoryID && errors.productCategoryID}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      All Product Categories
                    </MenuItem>
                    {productcatogery.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                          {option.productCategoryName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Grid item md={4} xs={12}>
                    <Autocomplete fullWidth
                      key={isFarmerClear}
                      id="cropID"
                      options={productList}
                      getOptionLabel={(option) => option.productName != null ? option.productName.toString() : null}
                      onChange={(e, value) => handleSearchCrop(value, e)}
                      defaultValue={null}
                      renderInput={(params) =>
                        <TextField {...params}
                          variant="outlined"
                          name="cropID"
                          label="Crop"
                          size="small"
                          fullWidth
                          value={formik.values.cropID}
                          getOptionDisabled={true}
                          helperText={touched.cropID && errors.cropID}
                          error={Boolean(touched.cropID && errors.cropID)}
                        />
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        size="small"
                        label="Date *"
                        openTo="day"
                        type="Date"
                        minDate={new Date().setDate(new Date().getDate())}
                        maxDate={new Date().setDate(new Date().getDate() + 6)}
                        views={['year', 'month', 'day']}
                        value={Datevalue}
                        onChange={(newValue) => {
                          setDateValue(newValue);
                        }}
                        renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="right" spacing={2}>
                      {PriceData.length !== 0 ? (
                        <Chip label="Market Prices" variant="filled" onClick={handleHartiPriceView} />
                      ) : null}
                      <Box sx={{ flexGrow: 1 }}></Box>
                      <Button
                        type="submit"
                        color="secondary"
                        variant="outlined"
                        onClick={() => trackPromise(SearchData())}
                      >
                        Search
                      </Button>
                    </Stack>
                  </Grid>
                </Stack>
              </Stack>
            </Form>
            <br />
            {PriceData.length != 0 ? (
              <>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    <Table size="small" stickyHeader aria-label="sticky table" border='1px'>
                      <TableHead>
                        <TableRow sx={{ border: '2px solid black', backgroundColor: '#E1F5FE' }}>
                          <TableCell rowSpan={2} sx={{ fontWeight: 'bold', backgroundColor: '#E1F5FE' }}>Crop Name</TableCell>
                          {columData.map((rows, i) => {
                            return (
                              <>
                                <TableCell align="center" colSpan={8} sx={{ fontWeight: 'bold', backgroundColor: '#E1F5FE' }}>{rows.title}</TableCell>
                              </>
                            );
                          })}
                        </TableRow>
                        <TableRow sx={{ border: '2px solid black', backgroundColor: '#E1F5FE' }}>
                          {columDataOne.map((rows, i) => {
                            return (
                              <>
                                <TableCell align="center" sx={{ top: 38, fontWeight: 'bold', backgroundColor: '#E1F5FE' }}>{rows.title}</TableCell>
                              </>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {PriceData.map((row, i) => {
                          return (
                            <>
                              <TableRow key={i} sx={{ height: '50px' }}>
                                <TableCell width={150} align='left'> {row.dataList[0].productName} </TableCell>
                                {columData.map((rows, index) => {
                                  const res = row.dataList.find(x => x.operationEntityID == rows.key)
                                  return (
                                    <>
                                      <TableCell align="right" width={50}>
                                        {res == undefined ? '-' : parseFloat(res.quantity).toFixed(2)}
                                      </TableCell>
                                      <TableCell align='center' width={50}>
                                        {res == undefined ? '-' :
                                          res.status == 3 ?
                                            <Chip label="Approved" color="primary" />
                                            : res.status == 1 ?
                                              <Chip label="Pending" variant="outlined" />
                                              : res.status == 2 ?
                                                <Chip label="Pending" variant="outlined" />
                                                : res.status == 4 ?
                                                  <Chip label="Rejected" color="error" />
                                                  : '-'}
                                      </TableCell>
                                      <TableCell align="right" width={50}>
                                        {res == undefined ? '-' : parseFloat(res.proposedPrice).toFixed(2)}
                                      </TableCell>
                                      <TableCell align="right" width={50}>
                                        {res == undefined ? '-' : res.status == 3 ? (
                                          res == undefined ? '-' : parseFloat(res.approvedPrice).toFixed(2)
                                        ) : (
                                          <TextField
                                            size="small"
                                            id="outlined-size-small"
                                            name="approvedPrice"
                                            defaultValue={0}
                                            onKeyDown={(evt) =>
                                              (evt.key === "-") && evt.preventDefault()
                                            }
                                            InputProps={{
                                              inputProps: {
                                                step: 0.01,
                                                type: 'number',
                                                style: {
                                                  textAlign: 'right',
                                                },
                                              },
                                            }}
                                            onWheel={event => event.target.blur()}
                                            onChange={(e) => changeText(e, i, row.cropID, rows.key)}
                                            value={res.approvedPrice}
                                          />
                                        )}
                                      </TableCell>
                                      <TableCell align="center" width={50}>
                                        {res == undefined ? '-' :
                                          res.secondProposedPriceStatus == 0 ?
                                            <Chip label="Not Set" variant="outlined" />
                                            :
                                            res.secondProposedPriceStatus == 1 ?
                                              <Chip label="Pending" variant="outlined" />
                                              :
                                              res.secondProposedPriceStatus == 2 ?
                                                <Chip label="Approved" color="primary" />
                                                :
                                                res.secondProposedPriceStatus == 3 ?
                                                  <Chip label="Rejected" color="error" />
                                                  : '-'}
                                      </TableCell>
                                      <TableCell align='right' width={res == undefined ? 50 : res.secondProposedPriceStatus == 1 ? 150 : 50}>
                                        {res == undefined ? '-' : res.secondProposedPriceStatus == 1 ?
                                          <div style={{ display: 'flex' }}>
                                            {res == undefined ? '-'
                                              : <Chip label={parseFloat(res.secondProposedPrice).toFixed(2)} variant="outlined" color='success' />}
                                            {res == undefined ? '-'
                                              : <Tooltip title="Reject">
                                                <IconButton aria-label="delete" onClick={() => RejectPopUpFuncSndPP(res)}>
                                                  <CloseIcon />
                                                </IconButton>
                                              </Tooltip>}
                                            {res == undefined ? '-'
                                              : <Tooltip title="Approve">
                                                <IconButton aria-label="delete" onClick={() => confirmMessageApproveSndPP(res)}>
                                                  <CheckIcon />
                                                </IconButton>
                                              </Tooltip>}
                                          </div>
                                          : parseFloat(res.secondProposedPrice).toFixed(2)
                                        }
                                      </TableCell>
                                      <TableCell align="right" width={res == undefined ? 50 : res.status == 3 && res.isRealizedEdited == true ? 200 : 50}>
                                        {res == undefined ? '-' : res.status == 3 && res.isRealizedEdited == true ?
                                          <div style={{ display: 'flex' }}>
                                            {res == undefined ? '-' :
                                              <Chip label={parseFloat(res.realizedPrice).toFixed(2)} variant="outlined" color='success' />}
                                            {res == undefined ? '-' :
                                              <Tooltip title="Reject">
                                                <IconButton aria-label="delete" onClick={() => RejectPopUpFunc(res)}>
                                                  <CloseIcon />
                                                </IconButton>
                                              </Tooltip>}
                                            {res == undefined ? '-' :
                                              <Tooltip title="Approve">
                                                <IconButton aria-label="delete" onClick={() => confirmMessageApprove(res)}>
                                                  <CheckIcon />
                                                </IconButton>
                                              </Tooltip>}
                                          </div>
                                          : parseFloat(res.realizedPrice).toFixed(2)
                                        }
                                      </TableCell>
                                      <TableCell align="center" width={50}>
                                        {res == undefined ? '-' :
                                          res.realizedPriceStatus == 0 ?
                                            <Chip label="Not Set" variant="outlined" />
                                            :
                                            res.realizedPriceStatus == 1 ?
                                              <Chip label="New" variant="outlined" />
                                              :
                                              res.realizedPriceStatus == 2 ?
                                                <Chip label="Pending" variant="outlined" />
                                                :
                                                res.realizedPriceStatus == 3 ?
                                                  <Chip label="Approved" color="primary" />
                                                  :
                                                  res.realizedPriceStatus == 4 ?
                                                    <Chip label="Rejected" color="error" />
                                                    : '-'}
                                      </TableCell>
                                    </>
                                  )
                                })}
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Stack>
                <br />
                <Divider variant="middle" />
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                  {PriceData.length != 0 ?
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        color="primary"
                        id="btnRecord"
                        type="submit"
                        variant="contained"
                        style={{ marginRight: '1rem' }}
                        className={classes.colorRecord}
                        onClick={() => createFile()}
                      >
                        EXCEL
                      </Button>
                      <ReactToPrint
                        documentTitle={"COP Report"}
                        trigger={() => <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem', backgroundColor: 'red' }}
                          onClick={() => getSelectedDropdownValuesForReport()}
                        >
                          PDF
                        </Button>}
                        content={() => componentRef.current}
                      />
                      <LoadingButton
                        type="button"
                        variant="contained"
                        color="secondary"
                        onClick={() => confirmMessage()}
                        loading={isLoading}
                        disabled={isUpdate == false}
                      >
                        {' '}
                        Update
                      </LoadingButton>
                      <div hidden={true}>
                        <CreatePDF ref={componentRef}
                          tableData={PriceData} searchData={selectedSearchValues}
                        />
                      </div>
                    </Box>
                    : null}
                </Stack>
              </>
            ) : <SearchNotFound searchQuery="Add Approved Price" />}
          </FormikProvider>
        </Container>
        <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title" maxWidth='lg'>
          <DialogTitle id="form-dialog-title">{"Market Price List"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Container>
                <Paper >
                  <TableContainer >
                    <Table
                      size="small"
                      border="2px"
                      aria-label="spanning table"
                    >
                      <TableHead>
                        <TableRow sx={{ border: '2px solid black' }}>
                          {MarketData.length > 0 ? (
                            <TableCell align="center" style={{ fontWeight: 'bold' }} colSpan={(1 + MarketCount) * 3} >
                              Harti Price Applicable Date : {MarketData[0].priceModel[0].date.split('T')[0]}
                            </TableCell>
                          ) : <TableCell align="center" style={{ fontWeight: 'bold' }} colSpan={(1 + MarketCount) * 3} >
                            Harti Price
                          </TableCell>}
                        </TableRow>
                        <TableRow sx={{ border: '2px solid black' }}>
                          <TableCell sx={{ border: '2px solid black' }} align="left" style={{ fontWeight: 'bold' }}>
                            Crop
                          </TableCell>
                          {MarketHeader.map((rows, index) => {
                            return (
                              <>
                                <TableCell sx={{ border: '2px solid black' }} align="left" style={{ fontWeight: 'bold' }}>
                                  {rows.key}
                                </TableCell>
                              </>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {MarketData.map((row, i) => {
                          return (
                            <TableRow key={i} sx={{ height: '50px' }}>
                              <TableCell component="th" scope="row" align="left">
                                {row.priceModel[0].productName}
                              </TableCell>
                              {row.priceModel.map((rows, index) => {
                                return (
                                  <>
                                    <TableCell component="th" scope="row" align="left">
                                      {rows == undefined ? '-' : rows.marketName}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right">
                                      {rows == undefined ? '-' : parseFloat(rows.priceMin).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" scope="row" align="right">
                                      {rows == undefined ? '-' : parseFloat(rows.priceMax).toFixed(2)}
                                    </TableCell>
                                  </>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                <DialogActions>
                  <Button onClick={handleClose} color="secondary">
                    CANCEL
                  </Button>
                </DialogActions>
              </Container>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
              discription={'Are you sure want to add Approved price ?'} setViewPopup={setEnableConfirmMessage} />
          </Grid>
        </div>
        <br />
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmDataRealizedApprove} headerMessage={messageRealizedApprove} viewPopup={EnableRealizeApproveConfirmMessage}
              discription={"Are you sure want to approve Realized Price ?"} setViewPopup={setEnableRealizeApproveConfirmMessage} />
          </Grid>
        </div>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmDataRealizedReject} headerMessage={messageRealizedReject} viewPopup={EnableRealizeRejectConfirmMessage}
              discription={"Are you sure want to reject Realized Price ?"} setViewPopup={setEnableRealizeRejectConfirmMessage} />
          </Grid>
        </div>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmDataSndPPReject} headerMessage={messageSndPPReject} viewPopup={EnableSndPPRejectConfirmMessage}
              discription={"Are you sure want to reject Second Proposed Price ?"} setViewPopup={setEnableSndPPRejectConfirmMessage} />
          </Grid>
        </div>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmDataSndPPApprove} headerMessage={messageSndPPApprove} viewPopup={EnableSndPPApproveConfirmMessage}
              discription={"Are you sure want to Approve Second Proposed Price ?"} setViewPopup={setEnableSndPPApproveConfirmMessage} />
          </Grid>
        </div>
      </Page >
    </>
  );
}
